import PropTypes from 'prop-types';

/**
 * Excel File Icon Component
 * Renders an Excel document icon with X mark
 * 
 * @param {string} className - Optional CSS class name
 * @param {number} size - Icon size in pixels (default: 18)
 * @param {string} color - Icon stroke color (default: Excel green)
 */
export default function ExcelIcon({ className, size = 18, color = 'var(--color-excel-icon, #217346)' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill="none"
    >
      {/* Document outline */}
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Folded corner */}
      <path
        d="M14 2v6h6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* X mark */}
      <path
        d="M9 12l6 6M15 12l-6 6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

ExcelIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
};

ExcelIcon.defaultProps = {
  className: '',
  size: 18,
  color: 'var(--color-excel-icon, #217346)',
};
